import React, { useEffect, useState } from "react";
import SoftBadge from "modules/common/SoftBadge";
import { getFormattedDate } from "modules/utilities/utility";
import PaginationDiv from "modules/pagination/PaginationDiv";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import moment from "moment";
import Loader from "modules/Loader";
import NoData from "assets/svgs/no_data/NoData";
import { Link } from "react-router-dom";

function TempEngagement({ tempData, tempLoading }) {
  const [page, newPage] = useState(1);
  const [sortData, setSortedData] = useState([]);
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [opa, setOpa] = useState("");
  const [opa1, setOpa1] = useState("");
  const [count, setCount] = useState(0);
  const [count1, setCount1] = useState(0);
  const [itemNew, setItemNew] = useState([]);
  useEffect(() => {
    setSortedData(tempData);
    newPage(1);
  }, [tempData]);

  let repeat;

  useEffect(() => {
    setItemNew([
      ...tempData?.map((item) => {
        repeat =
          item?.order?.count <= 1 ? "new" : `repeat${item?.order?.count}`;
        return { ...item, repeat: repeat };
      }),
    ]);
  }, [tempData]);

  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  const header = ["Name", "Order Id", "Status", "Tag"];

  const handleSortDueDate = () => {
    if (sortData.length == 0) {
      return;
    }
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setSortedData([
        ...tempData.sort((a, b) => moment(a?.due_date) - moment(b?.due_date)),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setSortedData([
        ...tempData.sort((a, b) => moment(b?.due_date) - moment(a?.due_date)),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setSortedData([...tempData]);
    }
  };

  const handleSortNewRepeat = () => {
    if (count1 === 0) {
      setOpa1("dsc");
      setCount1(1);
      setSortedData([...itemNew.sort(compareRepeat)]);
    } else if (count1 === 1) {
      setOpa1("asc");
      setCount1(2);
      setSortedData([...itemNew.sort(compareRepeat).reverse()]);
    } else if (count1 === 2) {
      if (opa1 === "") {
        setSortedData([...itemNew.sort(compareRepeat)]);
        setOpa1("dsc");
      } else if (opa1 === "dsc") {
        setSortedData([...itemNew.sort(compareRepeat).reverse()]);
        setOpa1("asc");
      } else {
        setSortedData([...itemNew]);
        setOpa1("");
      }
      setCount1(0);
    }
  };

  const compareRepeat = (a, b) => {
    const repeatOrderA = getRepeatOrder(a?.repeat);
    const repeatOrderB = getRepeatOrder(b?.repeat);

    if (repeatOrderA === repeatOrderB) {
      return a?.repeat.localeCompare(b?.repeat);
    } else {
      return repeatOrderA - repeatOrderB;
    }
  };

  const getRepeatOrder = (repeat) => {
    if (repeat === "new") {
      return Infinity; // "new" comes last
    } else if (repeat.startsWith("repeat")) {
      const match = repeat.match(/^repeat(\d+)$/);
      if (match) {
        return parseInt(match[1]);
      } else {
        return 0;
      }
    } else {
      return 1;
    }
  };

  return (
    <div>
      <table className="d-flex flex-column mt-3 rounded">
        <thead
          className="d-flex text-gray border-black border rounded-top "
          style={{ backgroundColor: "rgb(249,250,253)" }}
        >
          {header?.map((item) => (
            <th className="flex-1 fw-bold text-black  border-end py-3 px-2">
              {item}
            </th>
          ))}

          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                {count1 == 0 ? (
                  <span className="">Click to sort ascending</span>
                ) : count1 == 1 ? (
                  <span className="">Click to sort Descending</span>
                ) : (
                  <span className="">Click to cancel sort</span>
                )}
              </Tooltip>
            }
          >
            <th
              className="flex-1 fw-bold text-black border-end px-2 cursor-pointer"
              onClick={handleSortNewRepeat}
            >
              <span
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                <span> New/Repeat</span>
              </span>
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  paddingLeft: "1rem",
                }}
              >
                <div
                  className={
                    opa1 === ""
                      ? "opacity-100"
                      : opa1 === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </div>
                <div
                  className={
                    opa1 === ""
                      ? "opacity-100 mt-n2"
                      : opa1 === "dsc"
                      ? "opacity-50 mt-n2"
                      : "opacity-100 mt-n2"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </div>
            </th>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                {count == 0 ? (
                  <span className="">Click to sort ascending</span>
                ) : count == 1 ? (
                  <span className="">Click to sort Descending</span>
                ) : (
                  <span className="">Click to cancel sort</span>
                )}
              </Tooltip>
            }
          >
            <th
              style={{ position: "sticky", top: 0 }}
              className="flex-1 fw-bold text-black border-end px-2 cursor-pointer"
              onClick={handleSortDueDate}
            >
              <span
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                Due Date
              </span>
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  top: "0",
                  position: "sticky",
                  paddingLeft: "1rem",
                }}
              >
                <div
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </div>
                <div
                  className={
                    opa === ""
                      ? "opacity-100 mt-n2"
                      : opa === "dsc"
                      ? "opacity-50 mt-n2"
                      : "opacity-100 mt-n2"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </div>
            </th>
          </OverlayTrigger>
          <th className="flex-1 fw-bold text-black  py-3 px-2">
            Temporarily Assigned to
          </th>
        </thead>
        <div
          style={{ minHeight: "10vh", maxHeight:"52vh", overflowY: "scroll", overflowX:"hidden" }}
          className="scrollable-container"
        >
          {tempLoading ? (
            <div className="position-absolute mt-5 start-50 translate-middle">
              <Loader />{" "}
            </div>
          ) : filterData ? (
            filterData?.map((item, index) => {
              let tagData = item.reschedule_count !== 0 ? "Rescheduled" : null;
              let slotBooked = item.is_slot_booked ? "SLOT BOOKING" : null;
              const tag = [item?.tag, tagData, slotBooked];
              return (
                <tr
                  id="table-row-value"
                  key={item?._id}
                  className={`flex-1 border d-flex justify-content-between ${
                    index === filterData.length - 1 && `rounded-bottom`
                  }`}
                >
                  <td className="flex-1  p-1 text-left  border-end text-break  fw-bold">
                    <OverlayTrigger
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="overlay-trigger-example"
                        >
                          <div className="fw-bold">Lead Details</div>
                        </Tooltip>
                      }
                    >
                      <Link
                        to={`/lead-details/${item?.case_id}`}
                        className="text-primary cursor-pointer text-break text-wrap"
                      >
                        {item?.rep?.first_name}
                      </Link>
                    </OverlayTrigger>
                    <br></br>
                    <span>{item?.rep?.phone_number}</span>
                  </td>
                  <td className="flex-1  p-1 text-left fw-bold  border-end text-break text-black">
                    {item?.order?.order_display_id}
                  </td>
                  <td className="flex-1  p-1 fw-bold text-left  border-end text-break text-black">
                    <SoftBadge bg="primary" className="me-2">
                      {item?.status}
                    </SoftBadge>
                  </td>
                  <td className="flex-1  p-1  fw-bold text-left border-end text-break text-black">
                    <SoftBadge bg="primary" className="me-2 p-2">
                      {tag[0] || "-"}
                    </SoftBadge>
                    <SoftBadge bg="success" className="me-2 mt-1 p-2">
                      {tag[1]}
                    </SoftBadge>
                  </td>
                  <td className="flex-1  fw-bold  p-1 text-left border-end text-break text-black">
                    {item?.order?.count <= 1 ? (
                      <SoftBadge bg="primary" className="me-2">
                        New
                      </SoftBadge>
                    ) : (
                      <SoftBadge bg="success" className="me-2">
                        Repeat
                      </SoftBadge>
                    )}
                  </td>
                  <td className="flex-1  fw-bold p-1 text-left border-end text-break text-black">
                    {getFormattedDate(item?.due_date)}
                  </td>
                  <td className="flex-1 ms-1 me-n2 fw-bold  p-1 text-left  border-end text-break text-black">
                    {item?.temporary_assignment?.first_name}
                  </td>
                </tr>
              );
            })
          ) : (
            <div className="border p-2 rounded-bottom">
              <h3 className="text-center bg-white  text-black">
                Data not found <NoData />
              </h3>
            </div>
          )}
        </div>
      </table>
      <PaginationDiv
        paginationData={{ pageCount: pageCount || 1, page: page }}
        newPage={newPage}
      />
    </div>
  );
}

export default TempEngagement;
